<template>
<!--    fundregion2022@yandex.ru /forum_report-->
  <div>
    <SaveInfo
      :isDataUpdating="isDataUpdating"
    ></SaveInfo>
    <div v-if="!isLoading">
      <h1>Анкеты</h1>

      <div class="table__wrapper" style="overflow-x: auto;">
      <Table
          :dataSource="projects"
          :columns="columns"
          sticky
          @change="handleTableChange"
          :scroll="{ x: 1200, y: 400 }"
      >

        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'id_col'">
            <template v-if="record.type === 'forum_vector'">
              <a :href="'/project/forum_form/' + record.id" target="_blank"><FontAwesomeIcon icon="link"></FontAwesomeIcon></a>
            </template>
            <template v-else>
              <a :href="'/project/forum_form_guest/' + record.id" target="_blank"><FontAwesomeIcon icon="link"></FontAwesomeIcon></a>
            </template>
          </template>
          <template v-if="column.key === 'rep'">
            <template v-if="record.project_data.represents && (record.project_data.represents.length > 1 || record.project_data.represents.length === 1 && record.project_data.represents[0].fio.length > 0)">
              <template v-for="(represent, index) in record.project_data.represents" :key="index">
                <p>{{index + 1 }}: {{ represent.fio }}</p>
              </template>
            </template>
          </template>
          <template v-if="column.key === 'user'">
            {{ record.user.username }}
          </template>

          <template v-if="column.key === 'org_type'">
            <template v-if="record.type === 'forum_vector'">
              {{ record.project_data.part_role }}
            </template>
          </template>

          <template v-if="column.key === 'type'">
            <template v-if="record.type === 'forum_vector'">
              Организация
            </template>
            <template v-if="record.type === 'forum_vector_guest'">
              Физическое лицо
            </template>
            <template v-if="record.type === 'forum_vector_expert'">
              Физическое лицо
            </template>
          </template>
        </template>
      </Table>
      </div>

    </div>
    <div v-else style="text-align: center">
      <BaseLoader></BaseLoader>
    </div>
  </div>
</template>

<script>
import SaveInfo from "./Base/SaveInfo";
import BaseLoader from "./Base/BaseLoader";
import axios from "axios";
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import {library} from '@fortawesome/fontawesome-svg-core';
import {faLink} from '@fortawesome/free-solid-svg-icons';

library.add(faLink);

import {Table} from 'ant-design-vue';

export default {
  name: 'ForumForm',
  data() {
    return {
      isLoading: false,
      isDataUpdating: false,
      projects: [],
      columns: [
        {
          title: 'Анкета',
          key: 'id_col',
          fixed: 'left',
          width: 50
        },
        {
          title: 'Организация/ФИО',
          dataIndex: 'name',
          width: 150
        },
        {
          title: 'Представители',
          key: 'rep',
          width: 170
        },
        {
          title: 'Тип организации',
          key: 'org_type',
          width: 120,
          filters: [
            { text: 'Кинокомиссия', value: 'Кинокомиссия' },
            { text: 'Кинокомпания/Продюсерский центр', value: 'Кинокомпания/Продюсерский центр' },
            { text: 'Образовательное учреждение (кинообразование)', value: 'Образовательное учреждение (кинообразование)' },
            { text: 'Другое', value: 'Другое' },
          ],
        },
        {
          title: 'Телефон',
          dataIndex: 'film_rights_phone',
          width: 100
        },
        {
          title: 'Город',
          dataIndex: 'city',
          sorter: true,
          filters: [],
          width:100
        },
        {
          title: 'Регион',
          dataIndex: 'region',
          width: 100
        },
        {
          title: 'Пользователь',
          key: 'user',
          width: 120
        },
        {
          title: 'Тип анкеты',
          key: 'type',
          filters: [
            { text: 'Организация', value: 'forum_vector' },
            { text: 'Физическое лицо', value: 'forum_vector_guest' },
          ],
          width: 150
        }
      ],
    }
  },
  components: {
    SaveInfo,
    BaseLoader,
    Table,
    FontAwesomeIcon
  },
  mounted: function () {
    if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      alert("Эта страница может работать некорректно в браузере Safari. Рекомендуемые браузеры Яндекс.Браузер или Google Chrome.");
    }
    this.getData();
  },
  computed: {
    currentProjectId: function () {
      return window.projectId;
    },
    currentType: function () {
      return window.type;
    },
    uniqCities: function () {
      const uniqueValues = [];

      this.projects.forEach(item => {
        if (!uniqueValues.some(im => im.text === item.city)) {
          uniqueValues.push({ text: item.city, value: item.city });
        }
      });
      return uniqueValues
    }
  },
  methods: {
    async getData() {
      const items = await axios.get('/get_forum_projects');
      this.projects = items.data;

      this.columns = this.columns.map(item => {
        if (item['title'] === "Город") {
          return { ...item, filters: this.uniqCities };
        }
        return item;
      });

    },
    async handleTableChange(pagination, filters, sorter) {

      await this.getData();

      const { field, order } = sorter;
      if (field === 'city') {
        if (order === 'ascend') {
          this.projects.sort((a, b) => {return a.city?.localeCompare(b.city)});
        } else {
          this.projects.sort((a, b) => b.city?.localeCompare(a.city));
        }
      }

      const { type: typeFilters, city: cityFilters, org_type: orgTypeFilters } = filters;

      this.projects = this.projects.filter(record => {
        if (typeFilters && typeFilters.length > 0) {
          return typeFilters.includes(record.type);
        }
        if (cityFilters && cityFilters.length > 0) {
          return cityFilters.includes(record.city);
        }
        if (orgTypeFilters && orgTypeFilters.length > 0) {
          if (orgTypeFilters.includes('Другое')) {
            if (record.project_data.part_role !== 'Кинокомиссия' && record.project_data.part_role !== 'Кинокомпания/Продюсерский центр' && record.project_data.part_role !== 'Образовательное учреждение (кинообразование)') {
              return true;
            }
          }
          return orgTypeFilters.includes(record.project_data.part_role);
        }

        return true;
      });
    }

  }
}
</script>

<style>
.errors-block {
  color: red;
  border: 1px solid #999;
  border-radius: 10px;
  padding: 25px;
  margin-bottom: 30px;
}
.ant-table-filter-dropdown input[type="checkbox"] + *::before {
  display: none;
}
</style>
